import { atom } from "jotai";

export const PopoverAtom = atom<React.ReactNode | null>(null);

